import React from "react";
import {Navbar,Container} from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

import axios from "../api/axios";
const LOGOUT_URL = "/logout";

const NavbarCustom = () => {
    const navigate = useNavigate();
  const location = useLocation();
    const logout = async () =>{
        localStorage.removeItem('token')
        const response = await axios.get(
            LOGOUT_URL,
            {
              headers: { "Content-Type": "application/json" },
            }
          );
        navigate("/login")
    }  
  return (
    <Navbar className="nav-bar-msk">
      <Container>
        <Navbar.Brand className="text-white">
          {localStorage.getItem("company", JSON.stringify("company"))
            ? JSON.parse(localStorage.getItem("company", JSON.stringify("company")))
            : "Msk sistemas"}
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text>
            <a className='text-white text-decoration-none logout-pointer' onClick={logout}>Logout</a>
          </Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarCustom;
